// For full API documentation, including code examples, visit https://wix.to/94BuAAs
import wixData from 'wix-data';
$w.onReady(function () {
	//TODO: write your page related code here...

	var myVar = setInterval(myTimer, 1000);

	function myTimer() {
		var d = new Date();
		var t = d.toLocaleTimeString();
		$w('#text18').text = t;

	}

});

// export function button1_click(event) {

// $w("#dataset1").setFieldValue("proyekt", "בדיקה ");
// $w("#dataset1").save();
// // function myStopFunction() {
// //   clearInterval(myVar);
// // }

// 	//Add your code for this event here: 
// }

var x;
var startstop = 0;

export function startStop_click(event) {
	reset()
	startstop = startstop + 1;
	start();
	//   if (startstop === 1) {
	let toInsert = {
		"proyekt": $w('#input1').value,
		"pirut": $w('#input2').value,
	}
	wixData.insert("nocheut", toInsert)
		.then((results) => {
			let item = results;
			$w('#id').text = results._id

			$w('#startStop').hide()
			$w('#button5').show()
			$w('#dataset1').refresh()

		});
	// $w('#dataset1').new()

	//    $w('#startStop').label = "עצור";
	//   } else if (startstop === 2) {
	// $w('#startStop').label = "התחל";
	// startstop = 0;
	// stop();
	//   }

}

function start() {
	x = setInterval(timer, 10);
} /* Start */

function stop() {
	clearInterval(x);
} /* Stop */

var milisec = 0;
var sec = 0; /* holds incrementing value */
var min = 0;
var hour = 0;

/* Contains and outputs returned value of  function checkTime */

var miliSecOut = 0;
var secOut = 0;
var minOut = 0;
var hourOut = 0;

/* Output variable End */

function timer() {
	/* Main Timer */

	miliSecOut = checkTime(milisec);
	secOut = checkTime(sec);
	minOut = checkTime(min);
	hourOut = checkTime(hour);

	milisec = ++milisec;

	if (milisec === 100) {
		milisec = 0;
		sec = ++sec;
	}

	if (sec === 60) {
		min = ++min;
		sec = 0;
	}

	if (min === 60) {
		min = 0;
		hour = ++hour;

	}

	$w('#a').text = String(miliSecOut);
	$w('#sh').text = String(secOut);
	$w('#d').text = String(minOut);
	$w('#s').text = String(hourOut);

}

/* Adds 0 when value is <10 */

function checkTime(i) {
	if (i < 10) {
		i = "0" + i;
	}
	return i;
}

function reset() {

	/*Reset*/

	milisec = 0;
	sec = 0;
	min = 0
	hour = 0;

	$w('#a').text = "00";
	$w('#sh').text = "00";
	$w('#d').text = "00";
	$w('#s').text = "00";

}

// export function button3_click(event) {

// //  var a = $w('#a').text,
// //  b= $w('#sh').text,
// //   c=$w('#d').text,
// //  d= $w('#s').text;
// // var rr = $w('#s').text  +":" +  $w('#d').text +":" + $w('#sh').text +":" + $w('#a').text + "0";

// // console.log(rr);

// // $w("#dataset1").setFieldValue("time", "00:01");
// // $w("#dataset1").save();
// // ":" +$w('#d').text + ":" +  $w('#sh').text = ":" +   $w('#a').text)

// 	//Add your code for this event here: 

//   var d = new Date(),
//   tt= $w('#dataset1').getCurrentItem()._createdDate

// var diff = Math.abs(d - tt);
// console.log(diff);
// // Math.absמשמש כדי להיות מסוגל להשתמש בהבדל המוחלט (כך new Date('2011/10/09 00:00') - new Date('2011/10/09 12:00')נותן את אותה התוצאה).

// // חלוקת התוצאה ב -1000 מעניקה לך את מספר השניות. חלוק זה ב -60 נותן לך את מספר הדקות. כדי לעגל לדקות שלמות, השתמש Math.floorאו ב Math.ceil:
// var shniyot = Math.floor((diff/1000)/60/60);
// var minutes = Math.floor((diff/1000)/60/60/60);

// console.log(shniyot+ ":" +minutes);

// //   var rr = (tt-d)
// // console.log(d);
// // console.log(tt);
// // //   function dateDiffInDays() {
// // //     var date1 = new Date("05/30/2012");
// // //     var date2 = new Date("11/29/2013");
// // //     var utc1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
// 180921110

// }

export function button5_click(event) {
	stop()
	var d = new Date(),
		id = $w("#id").text;
	console.log(d);
	console.log(id);
	wixData.query('nocheut').eq('_id', id).find().then(res => {
		// console.log(res);
		let tt = res.items[0]._createdDate;

		console.log(tt);

		let diff = Math.abs(d - tt);
		console.log(diff);
		return Promise.all(res.items.map(item => {
			// item.torem = torem;
			item.time = diff
			item.zman = $w('#s').text + ":" + $w('#d').text + ":" + $w('#sh').text + ":" + $w('#a').text;
			item.proyekt = $w('#input1').value;
			item.pirut = $w('#input2').value;
			return wixData.update("nocheut", item);

		}));

	}).then(()=>{
		$w('#dataset1').refresh()
	})

	//   tt= $w('#dataset1').getCurrentItem();
	//   console.log(d);
	//   console.log(tt);
	// var diff = Math.abs(d - tt);
	// console.log(diff);

	// $w("#dataset1").setFieldValues( {
	// "time": diff,
	// "proyekt" : $w('#input1').value,
	// // "zman" :  $w('#s').text  +":" +  $w('#d').text +":" + $w('#sh').text +":" + $w('#a').text
	// } );
	// $w('#dataset1').save();
	//Add your code for this event here: 
	$w('#startStop').show()
	$w('#button5').hide()
}

export function button6_click(event) {
	
	const filter = wixData.filter().eq('tashlum', undefined);
		wixData.aggregate('nocheut')
			.filter(filter)
			.sum('time')
			.run()
			.then((res) => {
				let count = Number(res.items[0].timeSum );
				console.log(count);
// 	var s = (count/1000/60/60).toFixed(0),
// 	 d = (count/1000/60).toFixed(0),
// 	//  - s*24,
//  ss = (count/1000 -d *1000).toFixed(0);
// // 
// 	console.log(s+ ":" + d  + ":" + ss);
	

const milliseconds = count;

const hours = `0${new Date(milliseconds).getHours() - 2}`.slice(-2);
const minutes = `0${new Date(milliseconds).getMinutes()}`.slice(-2);
const seconds = `0${new Date(milliseconds).getSeconds()}`.slice(-2);

const time = `${hours}:${minutes}:${seconds}`
$w('#text27').text= time;
$w('#text27').show()

	// 
			})
	//Add your code for this event here: 
}

export function text27_click(event) {
const filter = wixData.filter().eq('tashlum', undefined);
		wixData.aggregate('nocheut')
			.filter(filter)
			.sum('time')
			.run()
			.then((res) => {
				let count = Number(res.items[0].timeSum );
				console.log(count);
// 	var s = (count/1000/60/60).toFixed(0),
// 	 d = (count/1000/60).toFixed(0),
// 	//  - s*24,
//  ss = (count/1000 -d *1000).toFixed(0);
// // 
// 	console.log(s+ ":" + d  + ":" + ss);
	

const milliseconds = count;

const hours = `0${new Date(milliseconds).getHours() - 2}`.slice(-2);
const minutes = `0${new Date(milliseconds).getMinutes()}`.slice(-2);
const seconds = `0${new Date(milliseconds).getSeconds()}`.slice(-2);

const time = `${hours}:${minutes}:${seconds}`
$w('#text27').text= time;


	// 
			})
	//Add your code for this event here: 
}

export function table1_click(event) {
$w('#box4').show()
$w('#box4').scrollTo()
	//Add your code for this event here: 
}

export function button8_click(event) {
$w('#box4').hide()
	//Add your code for this event here: 
}

export function button7_click(event) {
	$w('#dataset1').remove()
$w('#box4').hide()

	
	//Add your code for this event here: 
}